<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-toolbar color="#1f97b9" dark>
            <v-icon>far fa-user</v-icon>
            <v-toolbar-title>Ingresa a tu Cuenta</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="loginForm">
            <v-container grid-list-md py-0>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-alert
                    :value="alert.state"
                    :type="alert.tipo"
                    :icon="alert.icon"
                    transition="scale-transition"
                    class="py-1"
                  >
                    {{alert.texto}}
                  </v-alert>
                </v-flex>
                <v-flex xs12 v-if="!hideLogin">
                  <v-text-field v-model="data.email" label="Email" required :rules="rules.emailRules"></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="!hideLogin">
                  <v-text-field
                    v-model="data.password"
                    :append-icon="show ? 'fas fa-eye-slash' : 'fas fa-eye'"
                    :rules="rules.required"
                    :type="show ? 'text' : 'password'"
                    label="Contraseña"
                    @click:append="show = !show"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!hideLogin" color="blue darken-1" flat @click="recoverPass">¿Olvidaste tu contraseña?</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="!hideLogin" color="blue darken-1" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn v-if="!hideLogin" color="blue darken-1" flat @click="loginUser">Ingresar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import * as firebase from 'firebase/app'
  import 'firebase/auth'
  import { EventBus } from '../../events.js'
  import { validateEmail } from '@/utils/validate'
  export default{
    name: 'FormLogin',
    data () {
      const validEmail = (rule, value, callback) => {
        if (!validateEmail(value)) {
          callback(new Error('Email formato incorrecto'))
        } else {
          callback()
        }
      }
      return {
        hideLogin: false,
        dialog: false,
        show: false,
        data: {
          email: '',
          password: ''
        },
        loginRules: {
          email: [{ required: true, trigger: 'blur', validator: validEmail }],
          password: [{ required: true, trigger: 'blur' }]
        },
        alert: {
          state: false,
          texto: '',
          icon: 'fas fa-info-circle',
          tipo: 'info'
        },
        rules: {
          required: [value => !!value || 'Campo obligatorio'],
          min: [v => v.length >= 8 || 'Mínimo 8 caracteres'],
          emailRules: [
            v => !!v || 'Campo obligatorio',
            v => /.+@.+/.test(v) || 'Verifica que el email sea válido'
          ]
        }
      }
    },
    methods:{
      recoverPass() {
      const here = this
      if (validateEmail(this.data.email)) {
        const self = this
        firebase.auth().sendPasswordResetEmail(this.data.email).then(function() {
          here.alert.state = true
          here.alert.texto = 'Te hemos enviado un correo para restablecer tu contraseña.'
          here.alert.tipo = 'success'
          here.alert.icon = 'fas fa-check-circle'
          setTimeout(() => {
            here.alert.state = false
            here.alert.texto = ''
          }, 5000)
        }).catch(function(error) {
          here.alert.state = true
          here.alert.texto = 'Hubo un error al enviar el correo de confirmación, por favor intenta nuevamente.'
          here.alert.tipo = 'error'
          here.alert.icon = 'fas fa-exclamation-triangle'
          setTimeout(() => {
            here.alert.state = false
            here.alert.texto = ''
          }, 5000)
        })
      } else {
        here.alert.state = true
        here.alert.texto = 'Por favor ingresa tu correo en el campo correspondiente antes de solicitar restablecer tu contraseña. Y verifica que sea válido.'
        here.alert.tipo = 'error'
        here.alert.icon = 'fas fa-exclamation-triangle'
        setTimeout(() => {
          here.alert.state = false
          here.alert.texto = ''
        }, 5000)
      }
    },
      loginUser(){
        if(this.$refs.loginForm.validate()){
          const here = this
          firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            // var provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithEmailAndPassword(this.data.email, this.data.password)
            .then(function(data){
                  here.$store.state.idCliente = data.user.uid
                  here.alert.state = true
                  here.alert.texto = 'Has ingresado correctamente.'
                  here.alert.tipo = 'success'
                  here.alert.icon = 'fas fa-check-circle'
                  setTimeout(function() {
                    here.dialog = false
                  }, 1500);
                  here.eraseData()
          })
          .catch(function(error) {
            console.log("Login error: ", error)
            here.alert.state = true
            here.alert.texto = error.message
            here.alert.tipo = 'error'
            here.alert.icon = 'fas fa-exclamation-triangle'
            // ...
          });
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
          });
        }
      },
      eraseData() {
        this.hideLogin = true
        this.data.email = ''
        this.data.password = ''
        const here = this
        setTimeout(function() {
          here.hideLogin = false
          here.alert.state = false
          here.alert.texto = 'Has ingresado correctamente.'
          here.alert.tipo = 'info'
          here.alert.icon = 'fas fa-info-circle'
        },1600)
      }
    },
    mounted(){

      EventBus.$on('openLogin', data => {
        this.dialog = data
      })

    }
  }
</script>